<template>
  <div class="container p-0">
    <h1>{{ msg }}</h1>
    <div class="row no-gutters">

      <div class="col-12 col-sm-6 col-lg-3">
        <a href="/" class="card card--gray-light card__main">
          <span>PV</span>
        </a>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <a href="" class="card card--pink card__main">
          <span>News<br/>Feed</span>
        </a>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <a href="" class="card card--blue-dark card__main">
          <span>Bestell<br/>Modul</span>
        </a>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <a href="" class="card card--white card__secondary card__main">
          <span>Ärztebesucher<br/>Feedback<br/>Statistik</span>
        </a>
      </div>
    </div>

    <div class="row no-gutters">

      <div class="col-12 col-sm-6 col-lg-3">
        <a href="/" class="card card--teal card__main">
          <span>PV</span>
        </a>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <a href="" class="card card--yellow card__secondary card__main">
          <span>Firma<br/>fragen</span>
        </a>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <a href="" class="card card--blue card__main">
          <span>Benutzer-<br/>gruppen</span>
        </a>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <a href="" class="card card--green card__main">
          <span>Weiteres<br/>Feld</span>
        </a>
      </div>
    </div>

  </div>
</template>

<script>
    export default {
      name: 'ActionTiles',
      data () {
        return {
          msg: 'Cockpit'
        }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "./../assets/scss/_base.scss";

  .card {
    margin-right: 5px;
    margin-bottom: 5px;
    background: white;
    border-radius: 0;
    min-height: 230px;
    border: none;
    font-weight: 300;
      text-align: center;
    @include font-size($font_size);
    @media #{$netbook_break}{
      //  @include font-size($font_size_h2_big);
      //font-size: 2rem;
    }
  }

  .card--teal {
    border-top: 3px solid $teal;
    background-color: $teal;
  }

  .card--gray-light {
    border-top: 3px solid $gray_light;
    background-color: $gray_light;
  }

  .card--pink {
    border-top: 3px solid $pink;
    background-color: $pink;
  }

  .card--white {
    border-top: 3px solid white;
    background-color: white;
  }

  .card--blue {
    border-top: 3px solid $blue;
    background-color: $blue;
  }

  .card--yellow {
    border-top: 3px solid $yellow;
    background-color: $yellow;
  }

  .card--blue-dark {
    border-top: 3px solid $blue_dark;
    background-color: $blue_dark;
  }

  .card--green {
    border-top: 3px solid $green;
    background-color: $green;
  }

  .card__main {
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover, &:focus {
      color: white;
    }
  }

  .card__secondary {
    color: $gray;
    &:hover, &:focus {
      color: $gray;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ActionCards.vue